import { Language } from "../../assets/languages/langs";

export interface LoginTexts {
	/** Name of the language in itself, for the picker. */
	languageName: string;
	language: string;
	signIn: string;
	login: string;
	password: string;
	usernamePlaceholder: string;
	loginButton: string;
	errorTitle: string;
	emptyUsername: string;
	emptyPassword: string;
	invalidCredentials: string;
}

/**
 * Login screen texts. Built in: before login the server does not give
 * translations, and the screen must speak the dispatcher's language even
 * when the server is unreachable.
 */
export const LOGIN_TEXTS: Record<Language, LoginTexts> = {
	en: {
		languageName: "English",
		language: "Language",
		signIn: "Sign in",
		login: "Login",
		password: "Password",
		usernamePlaceholder: "username",
		loginButton: "Login",
		errorTitle: "Error",
		emptyUsername: "Please enter login",
		emptyPassword: "Please enter password",
		invalidCredentials:
			"You have entered an incorrect username or password",
	},
	uk: {
		languageName: "Українська",
		language: "Мова",
		signIn: "Вхід",
		login: "Логін",
		password: "Пароль",
		usernamePlaceholder: "ім'я користувача",
		loginButton: "Увійти",
		errorTitle: "Помилка",
		emptyUsername: "Введіть логін",
		emptyPassword: "Введіть пароль",
		invalidCredentials: "Неправильний логін або пароль",
	},
	ru: {
		languageName: "Русский",
		language: "Язык",
		signIn: "Вход",
		login: "Логин",
		password: "Пароль",
		usernamePlaceholder: "имя пользователя",
		loginButton: "Войти",
		errorTitle: "Ошибка",
		emptyUsername: "Введите логин",
		emptyPassword: "Введите пароль",
		invalidCredentials: "Неверный логин или пароль",
	},
	tr: {
		languageName: "Türkçe",
		language: "Dil",
		signIn: "Giriş",
		login: "Kullanıcı adı",
		password: "Şifre",
		usernamePlaceholder: "kullanıcı adı",
		loginButton: "Giriş yap",
		errorTitle: "Hata",
		emptyUsername: "Kullanıcı adını girin",
		emptyPassword: "Şifreyi girin",
		invalidCredentials: "Kullanıcı adı veya şifre yanlış",
	},
	az: {
		languageName: "Azərbaycan",
		language: "Dil",
		signIn: "Giriş",
		login: "Login",
		password: "Şifrə",
		usernamePlaceholder: "istifadəçi adı",
		loginButton: "Daxil ol",
		errorTitle: "Xəta",
		emptyUsername: "Logini daxil edin",
		emptyPassword: "Şifrəni daxil edin",
		invalidCredentials: "Login və ya şifrə yanlışdır",
	},
	ro: {
		languageName: "Română",
		language: "Limbă",
		signIn: "Autentificare",
		login: "Utilizator",
		password: "Parolă",
		usernamePlaceholder: "nume utilizator",
		loginButton: "Intră",
		errorTitle: "Eroare",
		emptyUsername: "Introduceți utilizatorul",
		emptyPassword: "Introduceți parola",
		invalidCredentials: "Utilizator sau parolă incorecte",
	},
	ka: {
		languageName: "ქართული",
		language: "ენა",
		signIn: "შესვლა",
		login: "მომხმარებელი",
		password: "პაროლი",
		usernamePlaceholder: "მომხმარებლის სახელი",
		loginButton: "შესვლა",
		errorTitle: "შეცდომა",
		emptyUsername: "შეიყვანეთ მომხმარებელი",
		emptyPassword: "შეიყვანეთ პაროლი",
		invalidCredentials: "მომხმარებელი ან პაროლი არასწორია",
	},
	pl: {
		languageName: "Polski",
		language: "Język",
		signIn: "Logowanie",
		login: "Login",
		password: "Hasło",
		usernamePlaceholder: "nazwa użytkownika",
		loginButton: "Zaloguj",
		errorTitle: "Błąd",
		emptyUsername: "Wpisz login",
		emptyPassword: "Wpisz hasło",
		invalidCredentials: "Nieprawidłowy login lub hasło",
	},
};

/** Picker order: English first, then as in the header list. */
export const LOGIN_LANGUAGE_ORDER: Language[] = [
	"en",
	"uk",
	"ru",
	"tr",
	"az",
	"ro",
	"ka",
	"pl",
];
